import { FC } from 'react';

import { CoOwner } from 'types';

import ShareEncumbranceViewCoOwnersTableRow from './ShareEncumbranceViewCoOwnersTableRow';

type Props = {
  mainCoOwner: CoOwner;
  coOwnersList: CoOwner[];
  handleRemoveCoOwner: (index: number) => void; // eslint-disable-line
};

const ShareEncumbranceViewCoOwnersTableBody: FC<Props> = ({
  mainCoOwner,
  coOwnersList,
  handleRemoveCoOwner,
}) => (
  <>
    <tbody>
      <ShareEncumbranceViewCoOwnersTableRow index={0} coOwner={mainCoOwner} />

      {coOwnersList?.map((coOwner: CoOwner, index: number) => (
        <ShareEncumbranceViewCoOwnersTableRow
          index={index}
          coOwner={coOwner}
          handleRemoveCoOwner={handleRemoveCoOwner}
        />
      ))}
    </tbody>
  </>
);

export default ShareEncumbranceViewCoOwnersTableBody;
